import * as React from 'react'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { Arrows } from './Arrows'
import { Announcement, Message } from '@/types'

declare const I18n;

type Props = {
  announcements: Array<Message>
  heading?: string
}

type State = {
  initialSettings: Record<string, any>
}

class FeaturedAnnouncementSlider extends React.Component<Props, State> {
  private sliderRef: React.RefObject<Slider>

  constructor(props: Props) {
    super(props)

    this.sliderRef = React.createRef()

    this.state = {
      initialSettings: {
        dots: true,
        autoplay: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }
  }

  render() {
    const { announcements, heading = announcements.length > 1
      ? I18n.t("models.announcement.attributes.featured_announcements")
      : I18n.t("models.announcement.attributes.featured_announcement")
    } = this.props
    return (
      <div>
        <div className="resource-heading-container">
          <h2 className="slider-section-heading">
            {heading}
          </h2>
          {announcements.length > 1 ? <Arrows sliderRef={this.sliderRef} /> : null}
        </div> 

        <div className="featured-announcement-slider" style={{ lineHeight: 0 }}>
          <Slider ref={this.sliderRef} {...this.state.initialSettings} style={{ lineHeight: 0 }}>
            {announcements.map((announcement, index) => {
              if (announcement.view_url && announcement.header_image_url) {
                return (
                  <a href={announcement.view_url} key={index}> 
                    <img src={announcement.header_image_url} alt={`Announcement ${index + 1}`} />
                  </a>
                )
              }

              return null
            })}
          </Slider>
        </div>
      </div>
    )
  }
}

export default FeaturedAnnouncementSlider